import React, { Component } from 'react';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";

class StatusSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    onOpen = () => {
        this.setState({ isOpen: true })
    };
    onClose = () => {
        this.setState({ isOpen: false })
    };
    render() {
        let statusOptions = this.props.statusOptions;
        const statusTexts = [
            {
                status: 'active',
                text: 'Activo'
            }, {
                status: 'inactive',
                text: 'Inactivo'
            }, {
                status: 'pending',
                text: 'Pendiente'
            }, {
                status: 'requested',
                text: 'Solicitado'
            }, {
                status: 'partial',
                text: 'Parcial'
            }, {
                status: 'received',
                text: 'Recibido'
            }, {
                status: 'invoiced',
                text: 'Facturado'
            }, {
                status: 'unpaid',
                text: 'Pendiente'
            }, {
                status: 'paid',
                text: 'Pagado'
            }, {
                status: 'accepted',
                text: 'Aceptado'
            }, {
                status: 'rejected',
                text: 'Rechazado'
            }, {
                status: 'in_progress',
                text: 'En Proceso'
            }, {
                status: 'sent',
                text: 'Enviado'
            }, {
                status: 'charged',
                text: 'Cobrado'
            }
        ];

        statusOptions = statusOptions.filter(status => status !== this.props.statusObject.get('status'));

        const popoverContent = (
            <Menu>
                { statusOptions.map(status => {
                        return (
                            <MenuItem
                                key={status}
                                text={ statusTexts.filter(statusText => statusText.status === status)[0].text }
                                onClick={ () => {
                                    this.props.changeStatus(this.props.statusObject.get('_id'), status);
                                }}

                            />
                        );
                    })
                }
            </Menu>
        );

        return (
            <Popover
                content={popoverContent}
                interactionKind={PopoverInteractionKind.CLICK}
                position={Position.BOTTOM_RIGHT}
                isOpen={this.state.isOpen}
                onClose={this.onClose}
            >
                <Icon
                    className={ `cursor-pointer ch-blue ${this.state.isOpen ? 'c-blue' : ''}` }
                    icon="cog"
                    title="Selector de Estado"
                    style={{margin: '0px 7px'}}
                    iconSize={20}
                    onClick={this.state.isOpen ? this.onClose : this.onOpen}
                />
            </Popover>
        );
    }

}

export default StatusSelector;


// WEBPACK FOOTER //
// ./src/components/common/StatusSelector.js